import React, { useState } from 'react';
import UserList from './components/user/userList/userList';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Dashboard from './components/dashboard/dashboard'
import {
  AppstoreOutlined, TeamOutlined, SettingOutlined,
  InfoCircleOutlined, NotificationOutlined,
  SaveOutlined, LogoutOutlined, TableOutlined
}
  from '@ant-design/icons';
import Versions from "./components/versions/versionTable";
import AboutUs from "./components/aboutUs/aboutUs";
import Settings from './components/settings/settings';
import {Layout, notification} from 'antd';
import 'antd/dist/antd.css';
import './App.css'
import './assets/css/font.css'
import './assets/css/reset.css'
import OperatorList from "./components/operators/operatorTable";
import Notification from "./components/notifications/notif";
import Logout from "./components/logout";
import AmlakList from "./components/amlak/amlakList";

const { Header, Content, Footer, Sider } = Layout;

function getItem(label, key, icon, children) {
  return { key, icon, children, label, };
}

const App = () => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation().pathname;
  const navigate = useNavigate();
  const rendering = {
    "/":<Dashboard/>,
    "/user-list": <UserList />,
    "/settings": <Settings />,
    "/about-us": <AboutUs/>,
    "/operators": <OperatorList/>,
    "/notification": <Notification/>,
    "/versions": <Versions/>,
    "/logout": <Logout/>,
    "/amlak-list": <AmlakList/>
  };


  if (localStorage.getItem('token') != null && localStorage.getItem('token') !== "" && localStorage.getItem('token') !== undefined) {
    return (

      <Layout style={{ minHeight: '100vh' }}>
        <Sider collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)}>
          <div className="logo" style={{ marginTop: '64px' }} />
          {
            collapsed === false
              ?
              <>
                <div>
                  <Link to={'/'}>
                    <div className={location === '/' ? "menuItemSelected" : "menuItem"} >
                      <AppstoreOutlined />
                      <p style={{ marginRight: '20px' }}>داشبورد</p>
                    </div>
                  </Link>

                  <Link to={"/user-list"}>
                    <div className={location === '/user-list' ? "menuItemSelected" : "menuItem"} >
                      <TeamOutlined />
                      <p style={{ marginRight: '20px' }}>لیست کاربران</p>
                    </div>
                  </Link>

                  <Link to={"/amlak-list"}>
                    <div className={location === '/amlak-list' ? "menuItemSelected" : "menuItem"} >
                      <TableOutlined />
                      <p style={{ marginRight: '20px' }}>لیست املاک ها</p>
                    </div>
                  </Link>


                    {/*<Link to={"/notification"}>*/}
                    {/*  <div className={location === '/notification' ? "menuItemSelected" : "menuItem"} >*/}
                    {/*    <NotificationOutlined />*/}
                    {/*    <p style={{ marginRight: '20px' }}>ارسال نوتیفیکیشن</p>*/}
                    {/*  </div>*/}
                    {/*</Link>*/}


                    <Link to={"/versions"}>
                      <div className={location === '/versions' ? "menuItemSelected" : "menuItem"} >
                        <SaveOutlined />
                        <p style={{ marginRight: '20px' }}>ورژن</p>
                      </div>
                    </Link>

                  <Link to={"/operators"}>
                    <div className={location === '/operators' ? "menuItemSelected" : "menuItem"} >
                      <TeamOutlined />
                      <p style={{ marginRight: '20px' }}>اپراتورها</p>
                    </div>
                  </Link>



                  <Link to={'/settings'}>
                    <div className={location === '/settings' ? "menuItemSelected" : "menuItem"}>
                      <SettingOutlined />
                      <p style={{ marginRight: '20px'}}>تنظیمات</p>
                    </div>

                    <Link to={'/about-us'}>
                      <div className={location === '/about-us' ? "menuItemSelected" : "menuItem"}>
                        <InfoCircleOutlined />
                        <p style={{ marginRight: '20px'}}>تماس با ما</p>
                      </div>
                    </Link>
                  </Link>

                  <Link to={'/logout'}>
                    <div className={location === '/logout' ? "menuItemSelected" : "menuItem"}>
                      <LogoutOutlined />
                      <p style={{ marginRight: '20px'}}>خروج</p>
                    </div>
                  </Link>


                </div>
              </>
              :
              <>
                <div>
                  <Link to={'/'}>
                    <div className={location === '/' ? "menuItemSelectedCpllapsed" : "menuCollapsed"} >
                      <AppstoreOutlined />
                    </div>
                  </Link>

                  <Link to={"/user-list"}>
                    <div className={location === '/user-list' ? "menuItemSelectedCpllapsed" : "menuCollapsed"} >
                      <TeamOutlined />

                    </div>
                  </Link>

                  <Link to={"/amlak-list"}>
                    <div className={location === '/amlak-list' ? "menuItemSelectedCpllapsed" : "menuCollapsed"} >
                      <TableOutlined />

                    </div>
                  </Link>

                  {/*<Link to={"/notification"}>*/}
                  {/*  <div className={location === '/notification' ? "menuItemSelectedCpllapsed" : "menuCollapsed"} >*/}
                  {/*    <NotificationOutlined />*/}
                  {/*  </div>*/}
                  {/*</Link>*/}

                  <Link to={"/versions"}>
                    <div className={location === '/versions' ? "menuItemSelectedCpllapsed" : "menuCollapsed"} >
                      <SaveOutlined />
                    </div>
                  </Link>

                  <Link to={'/operators'}>
                    <div className={location === '/operators' ? "menuItemSelectedCpllapsed" : "menuCollapsed"}>
                      <TeamOutlined />
                    </div>
                  </Link>

                  <Link to={'/settings'}>
                    <div className={location === '/settings' ? "menuItemSelectedCpllapsed" : "menuCollapsed"}>
                      <SettingOutlined />
                    </div>
                  </Link>

                  <Link to={'/about-us'}>
                    <div className={location === '/about-us' ? "menuItemSelectedCpllapsed" : "menuCollapsed"}>
                      <InfoCircleOutlined />
                    </div>
                  </Link>

                  <Link to={"/logout"}>
                    <div className={location === '/logout' ? "menuItemSelectedCpllapsed" : "menuCollapsed"}>
                      <LogoutOutlined />
                    </div>
                  </Link>
                </div>
              </>
          }

        </Sider>

        <Layout className="site-layout">
          <Header className="site-layout-background" style={{ padding: 0, }} />

          <Content id='contentStt' style={{ margin: '0 16px' }} >
            <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
              {rendering[location]}
            </div>
          </Content>

          <Footer style={{ textAlign: 'center', }}>
            <p id='footerText'> طراحی شده توسط کاسپین اکسین © 1401</p>
          </Footer>

        </Layout>

      </Layout>
    );
  }
  else {
    window.location.replace("/login");
  }
};

export default App;
